export default __webpack_public_path__ + "static/media/cl-3.0dbacce8.jpg";